import { pathOr } from 'ramda'

// appendData param adds fields in the object
// Should only be used to pass data from parent to children
// Do not abuse this
export const initArray = (init, path, Model, appendData = {}) => {
  const data = pathOr(false, path, init)
  return data
    ? data.map(
        item =>
          new Model({
            ...item,
            ...appendData
          })
      )
    : []
}

export const initArrayWithNodeExtract = (init, path, Model) => {
  const data = pathOr(false, path, init)
  return data ? data.map(({ node }) => new Model(node)) : []
}
